import React from 'react';
import RGBBackground from './RGBBackground';
import CyberMouseFollower from '../common/CyberMouseFollower';

export default function AuthLayout({ children }) {
    return (
        <div className="relative min-h-screen text-slate-100 selection:bg-cyber-blue/30 selection:text-white">
            <RGBBackground />
            <CyberMouseFollower />
            <main className="relative z-10">{children}</main>
        </div>
    );
}
